// BUS

export const PQ = 1;
export const PV = 2;
export const REF = 3;
export const NONE = 4;

export const BUS_I = 0;
export const BUS_TYPE = 1;
export const PD = 2;
export const QD = 3;
export const GS = 4;
export const BS = 5;
export const BUS_AREA = 6;
export const VM = 7;
export const VA = 8;
export const BASE_KV = 9;
export const ZONE = 10;
export const VMAX = 11;
export const VMIN = 12;

export const LAM_P = 13;
export const LAM_Q = 14;
export const MU_VMAX = 15;
export const MU_VMIN = 16;

// GEN

export const GEN_BUS = 0;
export const PG = 1;
export const QG = 2;
export const QMAX = 3;
export const QMIN = 4;
export const VG = 5;
export const MBASE = 6;
export const GEN_STATUS = 7;
export const PMAX = 8;
export const PMIN = 9;
export const PC1 = 10;
export const PC2 = 11;
export const QC1MIN = 12;
export const QC1MAX = 13;
export const QC2MIN = 14;
export const QC2MAX = 15;
export const RAMP_AGC = 16;
export const RAMP_10 = 17;
export const RAMP_30 = 18;
export const RAMP_Q = 19;
export const APF = 20;

export const MU_PMAX = 21;
export const MU_PMIN = 22;
export const MU_QMAX = 23;
export const MU_QMIN = 24;

// BRANCH

export const F_BUS = 0;
export const T_BUS = 1;
export const BR_R = 2;
export const BR_X = 3;
export const BR_B = 4;
export const RATE_A = 5;
export const RATE_B = 6;
export const RATE_C = 7;
export const TAP = 8;
export const SHIFT = 9;
export const BR_STATUS = 10;
export const ANGMIN = 11;
export const ANGMAX = 12;

export const PF = 13;
export const QF = 14;
export const PT = 15;
export const QT = 16;

export const MU_SF = 17;
export const MU_ST = 18;
export const MU_ANGMIN = 19;
export const MU_ANGMAX = 20;

// GENCOST

export const PW_LINEAR = 1;
export const POLYNOMIAL = 2;

export const MODEL = 0;
export const STARTUP = 1;
export const SHUTDOWN = 2;
export const NCOST = 3;
export const COST = 4;

// DCLINE

export const DCLINE_F_BUS = 0;
export const DCLINE_T_BUS = 1;
export const DCLINE_BR_STATUS = 2;
export const DCLINE_PF = 3;
export const DCLINE_PT = 4;
export const DCLINE_QF = 5;
export const DCLINE_QT = 6;
export const DCLINE_VF = 7;
export const DCLINE_VT = 8;
export const DCLINE_PMIN = 9;
export const DCLINE_PMAX = 10;
export const DCLINE_QMINF = 11;
export const DCLINE_QMAXF = 12;
export const DCLINE_QMINT = 13;
export const DCLINE_QMAXT = 14;
export const DCLINE_LOSS0 = 15;
export const DCLINE_LOSS1 = 16;
export const DCLINE_MU_PMIN = 17;
export const DCLINE_MU_PMAX = 18;
export const DCLINE_MU_QMINF = 19;
export const DCLINE_MU_QMAXF = 20;
export const DCLINE_MU_QMINT = 21;
export const DCLINE_MU_QMAXT = 22;
